export function formatString(value: string) {
  if (value.replace(/[^0-9]+/g, '').length === 0) return ''; // verify if it has a number before format the value
  let valueToFormat = value.replace(/[^0-9.]+/g, ''); // remove all not digits or dot characters
  const hasMoreThanOneDot = valueToFormat.replace(/[^.]+/g, '').length > 1;

  if (hasMoreThanOneDot) {
    // remove all dots and reallocate it
    valueToFormat = valueToFormat.replace(/[.]/g, '');
    const indexOfDot = valueToFormat.length - 2;
    valueToFormat = `${valueToFormat.substring(
      0,
      indexOfDot
    )}.${valueToFormat.substring(indexOfDot)}`;
  }

  let valueToNumber = Number(valueToFormat);
  const isFormatted = value.includes('.');

  if (isFormatted) {
    // increase/decrease at power of ten when user put/erase numbers after dot
    const hasMoreThanThreeNumbersAfterDot =
      valueToFormat.split('.')[1].length > 2;
    const hasMinusThanOneNumberAfterDot =
      valueToFormat.split('.')[1].length <= 1;
    let { length } = valueToFormat.split('.')[1];
    if (length === 0) length += 2;

    if (hasMoreThanThreeNumbersAfterDot) valueToNumber *= 10 ** (length - 2);
    else if (hasMinusThanOneNumberAfterDot) valueToNumber /= 10 ** length;
  }

  // if the value is not formatted, divide by 100 to format with cents
  const valueFormatted = isFormatted ? valueToNumber : valueToNumber / 100;
  const newValue = valueFormatted
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, '$&,');

  return newValue;
}

export function treatValue(value: number | string, fix: number = 2): string {
  let newValue = Number(value).toLocaleString('en-US', {
    minimumFractionDigits: fix
  });

  const splitedValue = newValue.split('.');

  newValue = splitedValue[1] == '00' ? splitedValue[0] : newValue;

  return newValue;
}

export function toNumber(value: string): number {
  const formatedString = value.replace(/[^0-9.]+/g, '');
  return +formatedString;
}
